function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "statses",
  transform: "translate(-42.000000, -74.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(42.000000, 74.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "currentColor",
  fillRule: "nonzero",
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.130174764,0.130174764 C0.284455966,-0.0241064378 0.523944322,-0.0412487935 0.697160447,0.0787476967 L0.758714125,0.130174764 L7.86982524,7.24128588 C8.04339159,7.41485223 8.04339159,7.69625888 7.86982524,7.86982524 C7.71554403,8.02410644 7.47605568,8.04124879 7.30283955,7.9212523 L7.24128588,7.86982524 L0.130174764,0.758714125 C-0.043391588,0.585147773 -0.043391588,0.303741116 0.130174764,0.130174764 Z",
  id: "Path",
  fill: "#003246",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.24128588,0.130174764 C7.41485223,-0.043391588 7.69625888,-0.043391588 7.86982524,0.130174764 C8.02410644,0.284455966 8.04124879,0.523944322 7.9212523,0.697160447 L7.86982524,0.758714125 L0.758714125,7.86982524 C0.585147773,8.04339159 0.303741116,8.04339159 0.130174764,7.86982524 C-0.0241064378,7.71554403 -0.0412487935,7.47605568 0.0787476967,7.30283955 L0.130174764,7.24128588 L7.24128588,0.130174764 Z",
  id: "Path",
  fill: "#003246",
  fillRule: "nonzero"
}))))));

var SvgNotExecuted = function SvgNotExecuted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotExecuted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notExecuted.7cd960bc.svg";
export { ForwardRef as ReactComponent };